import LoadingAnimation from 'components/Common/Loading/LoadingAnimation'
import BodyTextBlock from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import FlightDealsGrid from 'home/components/FlightDeals/FlightDealsGrid/FlightsDealsGrid'
import { useFlightCampaignDealsLocations } from 'home/hooks/useFlightCampaingDealsLocations'
import { useFlightCampaignDeals } from 'hooks/Flights/useFlightCampaignsDeals'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import Pane from 'components/Common/Pane'
import styled from 'styled-components'

interface Props {
  campaign: App.FlightCampaign
}

const TermsSection = styled(Pane)`
  padding: ${rem(32)} 0;
`

export default function FlightCampaignsDeals(props: Props) {
  const { campaign } = props
  const intl = useIntl()
  const [deals, loading] = useFlightCampaignDeals(campaign.id)
  const [airports, defaultAirport] = useFlightCampaignDealsLocations(campaign.id)
  const [selectedAirport, setSelectedAirport] = useState<App.Airport>()

  const flightDealsTitle = intl.formatMessage({
    id: 'mB0nqzDL0C_H2ED7y6Ko',
    defaultMessage: 'Flight deals from',
    description: 'Heading title for the flight campaign deals grid section',
  })
  const termsTitle = intl.formatMessage({
    id: 'FfScN3UhgXznP3p3DVrD',
    defaultMessage: 'Terms & Conditions',
    description: 'Heading for flight campaign terms and conditions section',
  })

  const showDeals = deals.length > 0 && !loading

  return (
    <>
      {loading && (
        <Group direction="horizontal" verticalAlign="center" horizontalAlign="center">
          <LoadingAnimation />
        </Group>
      )}

      {showDeals && (
        <>
          <FlightDealsGrid
            flightDeals={deals}
            airports={airports}
            defaultAirport={defaultAirport}
            onAirportChange={setSelectedAirport}
            selectedAirport={selectedAirport}
            hideAirlinesFilter={campaign.type === 'airline'}
            title={flightDealsTitle}
          />

          <TermsSection>
            <VerticalSpacer gap={4}>
              <Heading variant="heading6">{termsTitle}</Heading>
              <BodyTextBlock variant="small" colour="light-foreground-alt">
                {campaign.terms}
              </BodyTextBlock>
            </VerticalSpacer>
          </TermsSection>

        </>
      )}
    </>
  )
}
